import { Component, ViewChild, ViewContainerRef, Inject, AfterContentChecked, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material";
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { Subject, Subscription, EMPTY } from 'rxjs';

import { config } from "../../../config/index";

import { SnackbarService } from "../shared/services/snackbar.service";
import { VirtualCommunicationFollowUpService } from "./virtual-communication-follow-up.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import { LogoutService } from '../logout/logout.service';
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { PhoneFollowUpPopup } from '../shared/components/modal/phone-follow-up-popup/phone-follow-up-popup.component';
import { FollowUpEmail } from "../shared/components/modal/follow-up-email/follow-up-email.component";
import { PaginationComponent } from "../shared/components/pagination/pagination.component";
import { FollowUpSms } from '../shared/components/modal/follow-up-sms/follow-up-sms.component';
@Component({
    template: require('./virtual-communication-follow-up.component.html'),
    styles: [require('./virtual-communication-follow-up.component.less')],
    providers: [VirtualCommunicationFollowUpService, MatDialog, SnackbarService, LogoutService, TooltipService],
    preserveWhitespaces: true
})

export class VirtualCommunicationFollowUpComponent implements OnInit, AfterContentChecked, OnDestroy {

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild('communicationHistoryDialog', { static: false }) communicationHistoryDialog: any;
    @ViewChild('chatHistoryDialog', { static: false }) chatHistoryDialog: any;
    @ViewChild('previewMailBody', { static: false }) previewMailBody: any;
    @ViewChild('cancelTrackingDialog', { static: false }) cancelTrackingDialog: any;
    @ViewChild('assignBulkRefPatientDialog', { static: false }) assignBulkRefPatientDialog: any;
    @ViewChild('changeToTxPlanDialog', { static: false }) changeToTxPlanDialog: any;


    private followUpRedData: any[] = [];
    private followUpYellowData: any[] = [];
    private followUpGreenData: any[] = [];
    private followUpPurpleData: any[] = [];
    followUpListData: any[];
    followUpListCompleteData: any[] = [];
    filteredItems: any[];
    data: any = {};
    locationList: any[] = [];
    allTCList: any[] = [];
    startCount: number;
    followUpTotalCount: number;
    endCount: number;
    master: number;
    selectedType: any;
    paginationItems: any;
    locatManager: string;
    filterExpn: any = {};
    cooAdmin: string;
    followUpListNames: any[] = [];
    private _title: string;
    private _role = config.role;
    private _userRole: string;
    translatedText: string;
    dialogRefEmail: MatDialogRef<FollowUpEmail>;
    dialogRefPhone: MatDialogRef<PhoneFollowUpPopup>;
    dialogRefSms: MatDialogRef<FollowUpSms>;
    reqItemsPerPage: number;
    reqPageOffset: number = 0;
    searchValue: string = '';
    loading: boolean = true;
    updateDateForId: any;
    patientId: any = null;
    colWidth: any = 9;
    loadingFlag: boolean = false;
    messageType: any;
    message: any;
    TCList: any[] = [];
    tcIdValue: any;
    notificationFlag: boolean = false;
    cancelTrackingId: any;
    declinePlanId: any;
    sortParam: string;
    sortParams: any = ['id', 'patient_name', 'rp_full_name', 'location', 'trigger', 'last_accessed_at', 'last_mail_sent_at', 'over_due', 'expired_at', 'trigger', 'communication_count'];
    sortParamsConfig: any = [];
    order: string;
    BulkAssign: any = {};
    bulkAssignTCClass: any = 'selector';
    bulkAssignLocationClass: any = 'selector';
    selectAll: boolean = false;
    chatHistoryRooms: any = [];
    currentHistoryChatRoom: any;
    selectedRoom: any;
    selectedHistoryList: any;
    messageList: any = [];
    captcha: string;
    captcha_required: boolean = false;
    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    loadingDecline: boolean = false;
    orthoUrl: any;
    tx_captcha: string;
    tx_captcha_required: boolean = false;
    presentDataForVirtualPLan: any = {};
    isTouchDevice: boolean;
    dialogNewClasses: string;
    isInnerSidebarOpen: boolean = true;
    isShowAll: boolean;
    showText: string = 'SHOW_ALL';
    showAllToggleClicked: boolean = false;
    isToggleShowAll: boolean;
    actionListIsOpenFlag: boolean = false;

    limitInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    searchInputSub$: Subject<string> = new Subject<string>();
    searchSubscription: Subscription;
    apiSubscription: Subscription[] = [];
    locationSubscription: Subscription;
    followupFilterApiSubscription: Subscription;
    makeContactApiSubscription: Subscription;
    chatRoomApiSubscription: Subscription;
    showHistorySubscription: Subscription;

    utilServiceSubscriptions: Subscription[] = [];

    constructor(
        private _followUpCommunicationService: VirtualCommunicationFollowUpService,
        private _router: Router,
        private _logoutService: LogoutService,
        private _sessionStorageService: SessionStorageService,
        public dialog: MatDialog,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
        private _tooltipService: TooltipService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        @Inject('utilService') private utilService: any

    ) {
        this.utilServiceSubscriptions.push(this.utilService.callVcFollowUpAPI.subscribe(this.updateFollowUpList));
        this.utilServiceSubscriptions.push(this.utilService.pageListUpdateFromActionRequiredList.subscribe(this.updatePageLists));
    }

    updatePageLists = (data: any) => {
        // if (data.splice_list.includes('all')) {
        //     this.customerList('', this.followUpListData.length, 0);
        // } else {
        //     data.splice_list.forEach((splice_item: any) => {
        //         if (splice_item.followup_type === 'virtual_consultation_followup') {
        //             this.followUpListData = this.followUpListData
        //                 .filter((item: any) => item.id !== splice_item.original_id);
        //         }
        //     });
        // }
        this.customerList(this.searchValue, this.followUpListData.length, 0);
    }

    actionRequiredPendingCountUpdate = () => {
        this.utilService.updateActionRequiredListPendingCount.next({update: true});
    }

    updateFollowUpList = (data: any) => {
        if (data.callAPI) {
            this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
        }
    }

    goToPatientFile(list: any) {
        if (list.patient_file_id) {
            let viewData = JSON.parse(JSON.stringify(list));
            viewData.id = list.patient_file_id;
            this.viewPatient(viewData);
        }
    }

    viewPatient = (data: any) => {
        this._sessionStorageService.saveItem('viewPatientId', data);
        this._router.navigate(['patient/patient-file-view']);
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset)
    }

    customerList = (search: any, pageItems: any, offset: any, fromToggle?: boolean) => {
        this.loading = true;
        this.followupFilterApiSubscription?.unsubscribe();
        let itemLimit = this.isToggleShowAll ? null : pageItems;
        this.followupFilterApiSubscription = this._followUpCommunicationService.followUpFilterService(this.filterExpn, search, itemLimit, offset, this.patientId, this.sortParam, this.order)
            .subscribe(res => this.followUpListSuccessHandler(res, fromToggle),
                error => {
                    if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
                        this.showAllToggleClicked = false;
                        this.isToggleShowAll = !this.isToggleShowAll;
                    }
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role
            this.getLocations();
            if (this._userRole === 'TC') {
                this.colWidth = 10;
            }
        });
    }

    /**Sort list data based on days over due value **/
    overDueSort = (data: any[]) => {
        data.forEach((patient) => {
            if (patient.vc_status === 'virtual_treatment_plan_selected') {
                this.followUpPurpleData.push(patient);
                patient.className = "status-colorB";
            } else {
                if (patient.over_due > 0) {
                    this.followUpRedData.push(patient);
                    patient.className = "status-colorR";
                }
                else if (patient.over_due == 0) {
                    this.followUpYellowData.push(patient);
                    patient.className = "status-colorY";
                }
                else if (patient.over_due < 0) {
                    this.followUpGreenData.push(patient);
                    patient.className = "status-colorG";
                }
            }
            patient.backgroundClassName = "backgroundW";

            if (patient.opt_in_status === 'accepted') {
                patient.phoneClassName = "material-icons icon phone-icon-green";
            }
            else if (patient.opt_in_status === 'rejected') {
                patient.phoneClassName = "material-icons icon phone-icon-red";
            }
            else {
                patient.phoneClassName = "material-icons icon phone-icon-grey";
            }
            patient.idName = 'phone' + patient.patient.id;
        });
    }

    /**
    * Function for Folow Up List Success CallBack
    * @param  {any} response contains response from success CallBack
    */
    followUpListSuccessHandler = (response: any, fromToggle?: boolean) => {
        if (fromToggle) {
            this.setLimit(this.reqItemsPerPage, '', true);
        }

        if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
            this.isShowAll = !this.isShowAll;
            this.showText = (this.isShowAll) ? 'SHOW_LESS' : 'SHOW_ALL';
            this.showAllToggleClicked = false;
        }

        if (!response.data) {
            this.followUpListCompleteData = [];
            this.followUpListData = [];
        } else {
            this.followUpListCompleteData = response.data;
            this.followUpListData = response.data;
            this.overDueSort(response.data);
            this.followUpListData.forEach((listData) => {
                listData.openActionListFlag = false;
                listData.showHistory = false;
                listData.historyDataList = [];
            });
        }

        this.followUpTotalCount = response.count;
        if (this.reqPageOffset >= 0) {
            if (this.followUpListData.length !== 0) {
                this.startCount = this.reqPageOffset + 1;
                this.endCount = this.startCount + this.followUpListData.length - 1;
            } else {
                this.startCount = 0;
                this.endCount = 0;
            }
        }
        this.loading = false;
        return;
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any, fromToggle?: boolean) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            if (!fromToggle) {
                this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
            }
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.followUpTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        if (event.isClicked) {
            this.customerList(this.searchValue, event.itemsPerPage, event.offset);
        }
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    _openModal = (person: any, method: any, section: any) => {
        if (person.over_due !== null && person.over_due >= 0 && person.vc_status === 'virtual_treatment_plan_created') {
            person.section = section;
            person.method = method;
            if (method === 'email') {
                this.openEmailPreview(person, method);
            } else if (method === 'text') {
                this.openSmsPreview(person);
            }
        }
    }

    openEmailPreview(person: any, method: any) {
        var self = this;
        this._sessionStorageService.saveItem('emailDetails', person).then(() => {
            this.dialogRefEmail = this.dialog.open(FollowUpEmail);
            this._restrictOutsideScrollService.hideBackgroundScroll();
            this.dialogRefEmail.afterClosed().subscribe(result => {
                this._restrictOutsideScrollService.showBackgroundScroll();
                this.dialogRefEmail = null;
                this.data.method = method;
                this.data.message = result;

                if (self.data.message != 'cancel' && self.data.message != undefined) {
                    this.makeContactApiSubscription?.unsubscribe();
                    this.makeContactApiSubscription = this._followUpCommunicationService.makeContact(self.data, person.id)
                        .subscribe((res: any) => {
                            this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                            this.actionRequiredPendingCountUpdate();
                            this._mdlSnackbarService.showSnackbar('EMAIL_SEND_SUCCESS', 'success');
                        },
                            (error: any) => {
                                this._mdlSnackbarService.showSnackbar('EMAIL_SEND_FAIL', 'error');
                            });
                }
                else
                    return;
            });
        });
    }
    
    openSmsPreview(data: any) {
        if (data?.vc_status === 'virtual_treatment_plan_created' && data?.opt_in_status !== 'rejected') {
            this._sessionStorageService.saveItem('textDetails', data).then(() => {
                this.dialogRefSms = this.dialog.open(FollowUpSms, {
                    panelClass: 'sms-editor-popup-wrap',
                });
                this._restrictOutsideScrollService.hideBackgroundScroll();
                this.dialogRefSms.afterClosed().subscribe(result => {
                    this._restrictOutsideScrollService.showBackgroundScroll();
                })
            })
        }
    }

    formatAMPM(dateString: any) {
        let date = new Date(dateString);
        let hours = date.getHours();
        let minutes: any = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    showCommunicationHistory(id: any) {
        this.loading = true;
        this.followUpListData.forEach((listData) => {
            if (listData.id === id) {
                listData.showHistory = !listData.showHistory;
                if (listData.showHistory) {
                    this.showHistorySubscription?.unsubscribe();
                    this.showHistorySubscription = this._followUpCommunicationService.followUpHistory(id)
                        .subscribe((res: any) => {
                            listData.historyDataList = res.data;
                            this.loading = false;
                        },
                            error => {
                                this.loading = false;
                                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            });
                }
            }
            else {
                listData.showHistory = false;
            }
            this.loading = false;
        });
    }

    showHistoryPopup(list: any) {
        this.message = list.message;
        if (list.contact_method === 'text') {
            this.message = this.message.replace(/\n/g, "<br>");
            this.previewMailBody.nativeElement.setAttribute('style', 'width: 30vw');
        } else {
            this.previewMailBody.nativeElement.setAttribute('style', 'width: max-content');
        }
        this.previewMailBody.nativeElement.innerHTML = this.message;
        this.messageType = list.contact_method;
        this.communicationHistoryDialog.show();
    }

    showChatHistoryPopup(list: any) {
        this.messageList = [];
        this.selectedHistoryList = list;
        this.currentHistoryChatRoom = null;
        this.chatHistoryDialog.show();
        this.apiSubscription.push(this._followUpCommunicationService.getChatHistoryUsers(list.patient.id)
            .subscribe((res: any) => {
                this.setChatHistoryRooms(res);
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            }));
    }

    chatHistoryPopupClose() {
        this.chatHistoryDialog.close();
    }

    setChatHistoryRooms(res: any) {
        this.chatHistoryRooms = res.data.rooms;
    }

    getChatRoomDetails(room: any) {
        this.selectedRoom = room;
        this.selectedRoom['maxLimitReached'] = false;
        this.chatRoomApiSubscription?.unsubscribe();
        this.chatRoomApiSubscription = this._followUpCommunicationService.getChatRoomDetails(this.selectedRoom.id, 0, 5)
            .subscribe((res: any) => {
                if (this.selectedRoom.sender) {
                    this.setChatHistoryMessages(res, this.selectedRoom.sender?.user_id);
                }
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            })
    }

    setChatHistoryMessages(res: any, sender_id: any) {
        this.messageList = res.data;
        this.messageList.forEach((message: any) => {
            message['from'] = (message.member?.user_id === sender_id) ? 'user' : 'patient';
        });
    }

    fetchMessages() {
        if (!this.selectedRoom['maxLimitReached']) {
            this.chatRoomApiSubscription?.unsubscribe();
            this.chatRoomApiSubscription = this._followUpCommunicationService.getChatRoomDetails(this.selectedRoom.id, this.messageList.length, 5)
                .subscribe((res: any) => {
                    this.chatDetailsSuccessHandler(res);
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        }
    }

    chatDetailsSuccessHandler(res: any) {
        if (res.data.length > 0) {
            this.messageList = this.messageList.concat(res.data);
            this.messageList.forEach((message: any) => {
                if (this.selectedRoom.sender){
                    message['from'] = (message.member?.user_id === this.selectedRoom.sender?.user_id) ? 'user' : 'patient';
                }
            });
        } else {
            this.selectedRoom['maxLimitReached'] = true;
        }
    }

    messageTime(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        let timeString;
        let hours = msgdate.getHours();
        if (hours / 12 < 1) {
            timeString = 'AM';
            if (hours % 12 === 0) {
                hours = 12;
            }
        } else {
            timeString = 'PM';
            hours = hours - 12;
        }
        return ('0' + hours).slice(-2) + ":" + ('0' + msgdate.getMinutes()).slice(-2) + " " + timeString;
    }

    messageDate(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        return msgdate.getDate() + " " + this.months[msgdate.getMonth()] + " " + msgdate.getFullYear();
    }

    showMonthLine(display_list: any, index: any) {
        if (index > 0) {
            let currentChatMonth = new Date(display_list[index].sent_at);
            let previousChatMonth = new Date(display_list[index - 1].sent_at);
            if (currentChatMonth.getDate() !== previousChatMonth.getDate()) {
                return true;
            }
            return false;
        }
        return true;
    }

    historyPopupClose() {
        this.communicationHistoryDialog.close();
    }

    updateContactPopupOpen = (listData: any) => {
        if (listData.over_due !== null && listData.over_due >= 0 && listData.vc_status === 'virtual_treatment_plan_created') {
            this.dialogRefPhone = this.dialog.open(PhoneFollowUpPopup, {
                disableClose: true, panelClass: 'phone-follow-up-popup',
                data: {
                    listData: listData,
                    type: 'vc-follow-up'
                }
            });

            this.dialogRefPhone.afterClosed().subscribe(result => {
                if (result === 'updated') {
                    this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                    this.actionRequiredPendingCountUpdate();
                }
            });
        }
    }

    searchItem(value: any) {
        this.loading = true;
        this.reqPageOffset = 0;
        this.customerList(value, this.reqItemsPerPage, this.reqPageOffset);

    }

    resetPageOffset() {
        this.reqPageOffset = 0;
    }

    filterChange(parameter: any, value: any) {
        this.loading = true;
        this.resetPageOffset();
        if (this.searchValue === undefined)
            this.searchValue = '';
        if (this.reqItemsPerPage === undefined)
            this.reqItemsPerPage = 10;
        let itemLimit = this.isToggleShowAll ? null : this.reqItemsPerPage;
        if (value === undefined) {
            this.filterExpn.location = undefined;
            this.followupFilterApiSubscription?.unsubscribe();
            this.followupFilterApiSubscription = this._followUpCommunicationService.followUpFilterService(this.filterExpn, this.searchValue, itemLimit, this.reqPageOffset, this.patientId, this.sortParam, this.order)
                .subscribe((res: any) => this.followUpListSuccessHandler(res),
                    error => console.log(error));
        } else {
            this.locationList.forEach((location) => {
                if (location.id === value) {
                    this.filterExpn.location = value;
                    this.followupFilterApiSubscription?.unsubscribe();
                    this.followupFilterApiSubscription = this._followUpCommunicationService.followUpFilterService(this.filterExpn, this.searchValue, itemLimit, this.reqPageOffset, this.patientId, this.sortParam, this.order)
                        .subscribe((res: any) => this.followUpListSuccessHandler(res),
                            error => console.log(error));
                }
            });
        }
    }

    getLocations() {
        let req_filter = true;
        this.locationSubscription?.unsubscribe();
        if (this._userRole === 'TC'){
            this.locationSubscription = this._followUpCommunicationService.getLocationList(req_filter)
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error));
        } else {
            this.locationSubscription = this._followUpCommunicationService.getLocationList()
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error));
        }
    }

    initiate() {
        this._title = "Follow-Up Communications";
        this.selectedType = 10;
        this.userRoleFetch();
        this.customerList('', 10, 0);
        this.BulkAssign.treatment_plans = [];
        var table = document.getElementById('follow-up');
        this.locatManager = config.location_manager;
        this.cooAdmin = config.coo_admin;
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
    }

    openCancelTrackingConfirmationDialog(id: any) {
        this.cancelTrackingId = id;
        this.cancelTrackingDialog.show();
    }

    cancelTracking() {
        this.loading = true;
        this.apiSubscription.push(this._followUpCommunicationService.cancelTracking(this.cancelTrackingId)
            .subscribe((res: any) => {
                this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                this.actionRequiredPendingCountUpdate();
                this._mdlSnackbarService.showSnackbar('TRACKING_CANCELLED', 'success');
                this.loading = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                }));
        this.cancelTrackingDialog.close();
    }

    /**
    * Function for selecting a patient
    */

    selectPatient(patient_id: number, index: number) {
        event.stopPropagation();
        if (this.followUpListData[index].selected) {
            this.BulkAssign.treatment_plans.push(patient_id);
        }
        else {
            this.selectAll = false;
            let ind = this.BulkAssign.treatment_plans.indexOf(patient_id);
            if (index > -1) {
                this.BulkAssign.treatment_plans.splice(ind, 1);
            }
        }
    }

    /**
    * function for select all patients
    */

    selectAllpatients() {
        event.stopPropagation();
        this.BulkAssign.treatment_plans = [];
        var that = this;
        this.followUpListData.forEach(function (patient) {
            patient.selected = that.selectAll;
            that.BulkAssign.treatment_plans.push(patient.id);
        });
        if (!this.selectAll) {
            this.BulkAssign.treatment_plans = [];
        }
    }

    /**
    * Open bulk assign model
    */

    bulkAssign() {
        this.assignBulkRefPatientDialog.show();
    }

    /**
    * Close bulk assign model
    */

    assignBulkDialogClose() {
        this.assignBulkRefPatientDialog.close();
    }

    /**
    * Function for assign bulk
    */

    assignBulkTC() {
        if (this.BulkAssign.location_name && this.BulkAssign.tc) {
            this.BulkAssign.location = this.BulkAssign.location_name.id;
            this.apiSubscription.push(this._followUpCommunicationService.assignBulkTCUpdate(this.BulkAssign)
                .subscribe((res: any) => {
                    this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                    this.BulkAssign = {};
                    this.BulkAssign.treatment_plans = [];
                    this.selectAll = false;
                    this._mdlSnackbarService.showSnackbar('TC_ASSIGN_SUCCESS', 'success');
                },
                    error => console.log(error)));
            this.assignBulkRefPatientDialog.close();
        } else {
            if (!this.BulkAssign.location_name) {
                this.bulkAssignLocationClass = 'selector val-error';
            }
            if (!this.BulkAssign.tc) {
                this.bulkAssignTCClass = 'selector val-error';
            }
            this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
        }
    }

    changeToTxPlanDialogClose() {
        this.changeToTxPlanDialog.close();
    }

    changeVirtualToTxPlan() {
        if (this.tx_captcha === 'CONVERT') {
            this.changeToTxPlanDialog.close();
            this.apiSubscription.push(this._followUpCommunicationService.virtualPlanPresent(this.presentDataForVirtualPLan.treatment_plan_id)
                .subscribe((res: any) => {
                    this.presentPlan(this.presentDataForVirtualPLan);
                }, (error: any) => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
        } else {
            this.tx_captcha_required = true;
            this._mdlSnackbarService.showSnackbar('WRONG_CAPTCHA', 'error');
        }
    }

    openPresentPlanConfirmationPopup(planData: any) {
        this.presentDataForVirtualPLan = planData;
        this.tx_captcha = '';
        this.tx_captcha_required = false;
        this.changeToTxPlanDialog.show();
    }

    presentPlan(virtualAppointmentData: any) {
        if (virtualAppointmentData.treatment_plan_id) {
            this.loading = true;
            this.apiSubscription.push(this._followUpCommunicationService.getTreatmentPlan(virtualAppointmentData.treatment_plan_id)
                .subscribe((res: any) => {
                    const dobDigits = res.data.patient_file.patient.dob.split('-').join('');
                    const contactNumberdigits = res.data.patient_file.patient.contact_number.split('+').join('');
                    const key = (dobDigits + contactNumberdigits).replace(/ /g,'');
                    this.loading = false;
                    this.orthoUrl = window.open('', '_blank');
                    this.orthoUrl.document.write('Loading...');
                    this.orthoUrl.location.href = res.data.patient_url + "?startnow=true" + "&key=" + key;
                    this._logoutService.logout().
                        subscribe((res: any) => {
                            window.open('about:blank', '_parent', '').close();
                        },
                            error => {
                                this._router.navigate(['logout']);
                            });
                },
                    (error: any) => {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                        this.loading = false;
                    }));
        }
    }

    createVirtualPatient(virtualAppointmentData: any) {
        this._sessionStorageService.saveItem('viewPatientId', virtualAppointmentData);
        this._router.navigate(['patient/patient-file-add']);
    }

    onClickOutside(eve: any, index: any) {
        if( !this.actionListIsOpenFlag) {
            if (eve && eve.target.className.indexOf('dot-btn') === -1) {
                this.followUpListData[index].openActionListFlag = false;
            }
        }
        this.actionListIsOpenFlag = false;
    }

    createVirtualTreatmentPlan(virtualAppointmentData: any) {
        if (virtualAppointmentData.patient_file_id) {
            this.loading = true;
            this.apiSubscription.push(this._followUpCommunicationService.getPatientFile(virtualAppointmentData.patient_file_id)
                .subscribe((res: any) => {
                    res.data.patient_file_id = virtualAppointmentData.patient_file_id;
                    res.data.virtual_plan = true;
                    this._sessionStorageService.saveItem('viewPatientId', res.data).then(
                        data => this._router.navigate(['patient/treatment-plan'])
                    );
                    this.loading = false;
                },
                    (error: any) => {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                        this.loading = false;
                    }));
        }
    }

    OpenActionList(index: any) {
        this.actionListIsOpenFlag = true;
        this.followUpListData?.forEach((element :any,  i = 0) => {
            if( i === index) {
                element.openActionListFlag =   !element.openActionListFlag;
            } else {
                element.openActionListFlag = false;
            }   
        });
    }


    toggleShowAll() {
        this.showAllToggleClicked = true;
        this.isToggleShowAll = !this.isToggleShowAll;
        this.reqItemsPerPage = (this.isToggleShowAll) ? null : this.selectedType;
        this.reqPageOffset = 0;
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, true);
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe(params => {
            this.patientId = params['id'];
            if (this.notificationFlag) {
                this.initiate();
            }
            this.notificationFlag = true;
        });
        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();

        // add delay for search on typing
        this.searchSubscription = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(() => {
                this.searchItem(this.searchValue);
                return EMPTY;
            })
        ).subscribe();

        this.initiate();
    }

    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
        if (this.isTouchDevice) {
            this.dialogNewClasses = 'new-dialog-container';
        } else {
            this.dialogNewClasses = 'new-dialog-container desktop-view';
        }
    }

    ngOnDestroy() {
        this.communicationHistoryDialog.close();
        this.chatHistoryDialog.close();
        this.cancelTrackingDialog.close();
        this.assignBulkRefPatientDialog.close();
        this.changeToTxPlanDialog.close();
        this.dialogRefEmail?.close();
        this.dialogRefPhone?.close();
        this.dialogRefSms?.close();

        //Unsubscribing all the subscription
        this.inputSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe();
        this.makeContactApiSubscription?.unsubscribe();
        this.followupFilterApiSubscription?.unsubscribe();
        this.chatRoomApiSubscription?.unsubscribe();
        this.showHistorySubscription?.unsubscribe();
        this.locationSubscription?.unsubscribe();
        this.apiSubscription.forEach((subscription) => {
            subscription?.unsubscribe();
        });

        this.utilServiceSubscriptions.forEach(subscription => subscription?.unsubscribe());
    }
}
